export default [
  {
    path: '/app/caja/liquidacion',
    name: 'rt-caja-liquidacion',
    component: () => import('@/views/erp/caja/liquidacion/LiquidacionList.vue'),
    meta: {
      resource: 'rt-caja-liquidacion',
      pageTitle: 'Liquidacion',
      breadcrumb: [
        {
          text: 'Cajas',
        },
        {
          text: 'Liquidacion',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/caja/liquidacionform',
    name: 'rt-caja-liquidacionform',
    component: () => import('@/views/erp/caja/liquidacion/LiquidacionForm.vue'),
    meta: {
      resource: 'rt-caja-liquidacionform',
      pageTitle: 'Caja',
      breadcrumb: [
        {
          text: 'Nueva Liquidacion',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/caja/gasto',
    name: 'rt-caja-gasto',
    component: () => import('@/views/erp/caja/gasto/GastoList.vue'),
    meta: {
      resource: 'rt-caja-gasto',
      pageTitle: 'Gasto',
      breadcrumb: [
        {
          text: 'Cajas',
        },
        {
          text: 'Gasto',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/caja/gastoForm',
    name: 'rt-caja-gastoform',
    component: () => import('@/views/erp/caja/gasto/GastoForm.vue'),
    meta: {
      resource: 'rt-caja-gastoform',
      pageTitle: 'Caja',
      breadcrumb: [
        {
          text: 'Nueva Gasto',
          active: true,
        },
      ],
    },
  },
]
